<div [hidden]="!menuEnabled">
  <div class="row mt-3 mb-3">
    <div class="col-md-9 container my-auto" [formGroup]="form">
      <div class="row mt-3">
        <div class="col-md-12 text-center">
          <h4 class="text-cust-blue" translate>Contact DPA</h4>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-md-4 text-right">
          <label class="required" translate>Case type</label>
        </div>
        <div class="col-md-6">
          <select class="form-control" (change)="onCaseTypeChange()" formControlName="dpa_casetypeid">
            <option selected value="" translate>Select</option>
            <option *ngFor="let c of caseTypeList" [value]="c.dpa_casetypeid">
              {{c.dpa_name}}
            </option>
          </select>
          <span class="text-danger"
            *ngIf="submitted && (formControl.dpa_casetypeid.value == null || formControl.dpa_casetypeid.value.trim().length == 0) && formControl.dpa_casetypeid.errors?.required">
            <label translate>Please specify</label> <label translate>Case type</label>
            <!-- กรุณาระบุประเภทรายการติดต่อ -->
          </span>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-md-4 text-right">
          <label class="required" translate>Topic</label>
        </div>
        <div class="col-md-6">
          <select class="form-control" (change)="onCaseSubTypeChange()" formControlName="dpa_casesubtypeid">
            <option selected value="" translate>Select</option>
            <option *ngFor="let c of caseSubTypeList" [value]="c.dpa_casesubtypeid">
              {{c.dpa_name}}
            </option>
          </select>
          <span class="text-danger" translate
            *ngIf="submitted && (formControl.dpa_casesubtypeid.value == null || formControl.dpa_casesubtypeid.value.trim().length == 0) && formControl.dpa_casesubtypeid.errors?.required">
            <label translate>Please specify</label> <label translate>Topic</label>
            <!-- กรุณาระบุเรื่อง -->
          </span>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-md-4 text-right">
          <label class="required" translate>Details</label>
        </div>
        <div class="col-md-6">
          <select class="form-control" formControlName="dpa_casesubtypedetailid">
            <option selected value="" translate>Select</option>
            <option *ngFor="let c of caseSubTypeDetailList" [value]="c.dpa_casesubtypedetailid">
              {{c.dpa_name}}
            </option>
          </select>
          <span class="text-danger" translate
            *ngIf="submitted && (formControl.dpa_casesubtypedetailid.value == null || formControl.dpa_casesubtypedetailid.value.trim().length == 0) && formControl.dpa_casesubtypedetailid.errors?.required">
            <label translate>Please specify</label> <label translate>Details</label>
            <!-- กรุณาระบุรายละเอียดเรื่อง -->
          </span>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-md-4 text-right">
          <label [className]="'required'" translate>Description</label>
        </div>
        <div class="col-md-7">
          <textarea class="form-control" rows="4" formControlName="description" maxlength="500"></textarea>
          <span class="text-danger" translate
            *ngIf="submitted && (formControl.description.value == null || formControl.description.value.trim().length == 0) && formControl.description.errors?.required">
            <label translate>Please specify</label> <label translate>Description</label>
            <!-- กรุณาระบุรายละเอียดข้อความ -->
          </span>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-md-4 text-right">
          <label class="required" translate>Name</label>
        </div>
        <div class="col-md-6">
          <input type="text" class="form-control" formControlName="firstname" maxlength="100">
          <span class="text-danger" translate
            *ngIf="submitted && (formControl.firstname.value == null || formControl.firstname.value.trim().length == 0) && formControl.firstname.errors?.required">
            <label translate>Please specify</label> <label translate>Name</label>
            <!-- กรุณาระบุชื่อ -->
          </span>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-md-4 text-right">
          <label class="required" translate>Surname</label>
        </div>
        <div class="col-md-6">
          <input type="text" class="form-control" formControlName="lastname" maxlength="100">
          <span class="text-danger" translate
            *ngIf="submitted && (formControl.lastname.value == null || formControl.lastname.value.trim().length == 0) && formControl.lastname.errors?.required">
            <label translate>Please specify</label> <label translate>Surname</label>
            <!-- กรุณาระบุนามสกุล -->
          </span>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-md-4 text-right">
          <label [className]="isComplain ? 'required' : ''" translate>ID no.</label>
        </div>
        <div class="col-md-6">
          <input type="text" class="form-control number" maxlength="13" formControlName="dpa_idcard">
          <span class="text-danger" translate
            *ngIf="submitted && (formControl.dpa_idcard.value == null || formControl.dpa_idcard.value.trim().length == 0) && isComplain">
            <label translate>Please specify</label> <label translate>ID no.</label>
            <!-- กรุณาระบุเลขบัตรประชาชน -->
          </span>
          <span class="text-danger" translate
            *ngIf="(formControl.dpa_idcard.value != null && formControl.dpa_idcard.value.trim().length > 0 && formControl.dpa_idcard.value.trim().length != 13) ">
            <label translate>idNo13</label>
            <!-- กรุณาระบุเลขบัตรประชาชนให้ครบ 13 หลัก -->
          </span>
         <!-- <span class="text-danger" translate
            *ngIf="form.get('dpa_idcard').invalid && (form.get('dpa_idcard').dirty || form.get('dpa_idcard').touched) ">
            <label translate>idNoInvalid</label>
          </span>-->
            <!-- กรุณาระบุเลขบัตรประชาชนให้ถูกต้อง -->
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-md-4 text-right">
          <label [className]="isComplain ? 'required' : ''" translate>Address</label>
        </div>
        <div class="col-md-6">
          <input type="text" class="form-control" formControlName="dpa_contact_homeno" maxlength="500">
          <span class="text-danger" translate
            *ngIf="submitted && (formControl.dpa_contact_homeno.value == null || formControl.dpa_contact_homeno.value.trim().length == 0) && isComplain">
            <label translate>Please specify</label> <label translate>Address</label>
            <!-- กรุณาระบุ ที่อยู่ -->
          </span>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-md-4 text-right">
          <label translate>Moo</label>
        </div>
        <div class="col-md-1">
          <input type="text" class="form-control" formControlName="dpa_contact_moo" maxlength="100">
        </div>

        <div class="col-md-1 text-right">
          <label [className]="isComplain ? 'required' : ''" translate>Street</label>
        </div>
        <div class="col-md-4">
          <input type="text" class="form-control" formControlName="dpa_contact_street" maxlength="100">
          <span class="text-danger" translate
            *ngIf="submitted && (formControl.dpa_contact_street.value == null || formControl.dpa_contact_street.value.trim().length == 0) && isComplain">
            <label translate>Please specify</label> <label translate>Street</label>
            <!-- กรุณาระบุ ถนน -->
          </span>
        </div>
      </div>

      <div class="row mt-3 select2-th">
        <div class="col-md-4 text-right">
          <label [className]="isComplain ? 'required' : ''" translate>Select Location</label>
        </div>
        <div class="col-md-6">
          <select class="form-control select2 select2th">
            <option value="" translate>Select</option>
            <option *ngFor="let sd of combinedAddressList" [value]="sd.id">
              {{sd.text}}
            </option>
          </select>
          <span class="text-danger" translate
            *ngIf="submitted && (formControl.dpa_contact_subdistict.value == null || formControl.dpa_contact_subdistict.value.trim().length == 0) && isComplain">
            <label translate>Please specify</label>
          </span>
        </div>

      </div>

      <div class="row mt-3 select2-en">
        <div class="col-md-4 text-right">
          <label [className]="isComplain ? 'required' : ''" translate>Select Location</label>
        </div>
        <div class="col-md-6">
          <select class="form-control select2 select2en">
            <option value="" translate>Select</option>
            <option *ngFor="let sd of combinedAddressListEn" [value]="sd.id">
              {{sd.text_eng}}
            </option>
          </select>
          <span class="text-danger" translate
            *ngIf="submitted && (formControl.dpa_contact_subdistict.value == null || formControl.dpa_contact_subdistict.value.trim().length == 0) && isComplain">
            <label translate>Please specify</label>
          </span>
        </div>

      </div>

      <div class="row mt-3">
        <div class="col-md-4 text-right">
          <label [className]="isComplain ? 'required' : ''" translate>Sub-district</label>
        </div>
        <div class="col-md-3">
          <input type="text" class="form-control" formControlName="dpa_contact_subdistictname" readonly>
        </div>
        <div class="col-md-2 text-right">
          <label [className]="isComplain ? 'required' : ''" translate>District</label>
        </div>
        <div class="col-md-3">
          <input type="text" class="form-control" formControlName="dpa_contact_distictname" readonly>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-md-4 text-right">
          <label [className]="isComplain ? 'required' : ''" translate>Province</label>
        </div>
        <div class="col-md-3">
          <input type="text" class="form-control" formControlName="dpa_contact_provincname" readonly>
        </div>
        <div class="col-md-2 text-right">
          <label [className]="isComplain ? 'required' : ''" translate>Postal code</label>
        </div>
        <div class="col-md-3">
          <input type="text" class="form-control" formControlName="dpa_contact_postcodename" readonly>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-md-4 text-right">
          <label class="required" translate>e-mail</label>
        </div>
        <div class="col-md-6">
          <input type="text" class="form-control" formControlName="emailaddress1" maxlength="100">
          <span class="text-danger" translate
            *ngIf="submitted && (formControl.emailaddress1.value ==null || formControl.emailaddress1.value.trim().length == 0)">
            <label translate>Please specify</label> <label translate>e-mail</label>
            <!-- กรุณาระบุอีเมล -->
          </span>
          <span class="text-danger" translate
            *ngIf="form.get('emailaddress1').invalid && (form.get('emailaddress1').dirty || form.get('emailaddress1').touched)">
            <label translate>emailInvalid</label>
            <!-- อีเมลไม่ถูกต้อง -->
          </span>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-md-4 text-right">
          <label class="required" translate>Telephone no.</label>
        </div>
        <div class="col-md-6">
          <input type="text" class="form-control" (keypress)="telephoneOnly($event)" (keypress)="telephoneOnly($event)"
            formControlName="telephone1" maxlength="100">
          <span class="text-danger" translate
            *ngIf="submitted && (formControl.telephone1.value == null || formControl.telephone1.value.trim().length == 0) && formControl.telephone1.errors?.required">
            <label translate>Please specify</label> <label translate>Telephone no.</label>
            <!-- กรุณาระบุเบอร์โทรศัพท์ -->
          </span>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-md-4"></div>
        <div class="col-md-6">
          <div class="row">
            <div class="col-12 pl-0 mb-1">
              <div class="input-group">
                <canvas id="canvas"></canvas>
                <button class="btn btn-primary  mt-2 mb-2 ml-2 mr-0" (click)="refreshCaptcha()" translate>
                  Change code
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4">

        </div>
        <div class="col-md-6">
          <input name="code" class="form-control" placeholder="{{'Type code' | translate}}">
          <span class="text-danger" *ngIf="submitted && !captchaMatch" translate>
            <label translate>Type code</label>
          </span>
        </div>
      </div>

      <div class="row mt-3 mb-3">
        <div class="col-md-12 text-center">
          <button class="btn btn-default mr-2" (click)="sendToDPA()" translate>SendToDpa</button>
          <button class="btn btn-default ml-2" (click)="clear()" translate>Clear</button>
        </div>
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/contact-dpa/contact-dpa.component.html